import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MobileBookingAvailabilityComponent } from './mobile-booking-availability.component';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { DisplayVesselRatesModule } from '../charter-buyflow-customer-booking/display-vessel-rates/display-vessel-rates.module';
import { MatTabsModule } from '@angular/material/tabs';
import { TermPriceDetailsModule } from '../charter-buyflow-customer-booking/term-price-details/term-price-details.module';
import { LoadingModule } from '../../../shared/loading/loading.module';

@NgModule({
  declarations: [MobileBookingAvailabilityComponent],
  providers: [
    {
      provide: MAT_BOTTOM_SHEET_DATA,
      useValue: {},
    },
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatTabsModule,
    DisplayVesselRatesModule,
    TermPriceDetailsModule,
  ],
})
export class MobileBookingAvailabilityModule {}
